import ApiPermisos from './../../services/apiPermisos'


export default {
  namespaced: true,
  // state,
  // actions,
  // mutations,
  // getters
  state: {
    template: '',
    errorMsj: '',
    loading: '',
  },
  getters: { getTemplateGetter: (state) => state.template.data || {} },
  mutations: {
    setTemplate: (state, template) => {
      state.template = template;
    },
    SetErrorMsj:(state, errorMsj) => {
      state.errorMsj = errorMsj;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },
  },
  actions: {
    /*
     *
     * EDIT LETTER 
     * 
     */
    actGetTemplate: async ({
      commit
      }) => {
        let response = await ApiPermisos.GetTemplate();
        if (response.error) {
            return response.error;
        }
        commit('setTemplate', response);
        return true;
    },

    actChangeLetter: async ({
      commit
    }, data) => {
      commit('setLoading', true); // Start loading
      let response = await ApiPermisos.changeLetter(data);
      commit('setLoading', false); // Start loading
      commit('SetErrorMsj', response);
      if (response.error) {
        return response.error;
      }
      else{
        return response;
      }
    },
  },
}